module.exports = __webpack_public_path__ + "img/stop_btn.19a18b20.png";